import QuotationCard from "./quotation-card.container";

export default QuotationCard;
